import React, { useEffect, useState } from "react";
import styles from "./style.module.scss";
import { getApplicationsData } from "../../../../../api";
import useDashboardStore from "../../../../stores/dashboard";

const Applications = () => {
  const filterDataStartDate = useDashboardStore((s) => s.filterData.startDate);
  const filterDataEndDate = useDashboardStore((s) => s.filterData.endDate);
  const filterUser = useDashboardStore((s) => s.filterUser);
  const filterOrg = useDashboardStore((s) => s.filterOrg);

  useEffect(() => {
    getApplicationsData({
      first_date: filterDataStartDate,
      end_date: filterDataEndDate,
      user_id: filterUser,
      org_id: filterOrg,
    }).then((res) => {
      if (res.status) {
        setApplicationsData(res.data);
        let total = res.data.reduce((acc, item) => acc + item.value, 0);
        setBarData(
          res.data.map((item, index) => ({
            title: item.title,
            barPercentage: ((item.value / total) * 100).toFixed(2),
            color: item.color,
          })),
        );
      }
    });
  }, [filterDataStartDate, filterDataEndDate, filterUser, filterOrg]);

  const applications = [
    {
      title: "Pending Prevet",
      description: "36% of all applications",
      value: 80,
      color: "#400006",
    },
    {
      title: "App in progress",
      description: "4% of all applications",
      value: 660,
      color: "#E3B8FC",
    },
    {
      title: "Signed - PC Review",
      description: "45% of all applications",
      value: 10,
      color: "#004CA3",
    },
    {
      title: "Underwriting Review",
      description: "10% of all applications",
      value: 99,
      color: "#FCFFAC",
    },
    {
      title: "Approved",
      description: "10% of all applications",
      value: 229,
      color: "#19A81E",
    },
    {
      title: "Declined",
      description: "0.02% of all applications",
      value: 120,
      color: "#E15E5E",
    },
  ];

  const [applicationsData, setApplicationsData] = useState([]);
  const [barData, setBarData] = useState([
    {
      title: "Pending Prevet",
      barPercentage: 95,
      color: "#400006",
    },
    {
      title: "App in progress",
      barPercentage: 1,
      color: "#E3B8FC",
    },
    {
      title: "Signed - PC Review",
      barPercentage: 1,
      color: "#004CA3",
    },
    {
      title: "Underwriting Review",
      barPercentage: 1,
      color: "#FCFFAC",
    },
    {
      title: "Approved",
      barPercentage: 1,
      color: "#19A81E",
    },
    {
      title: "Declined",
      barPercentage: 1,
      color: "#E15E5E",
    },
  ]);

  return (
    <div className={styles.applications}>
      <div className={styles.applicationsHeader}>
        <p className={styles.applicationsHeaderTitle}>Applications</p>
        <p className={styles.applicationsHeaderDate}>
          {filterDataStartDate} - {filterDataEndDate}
        </p>
      </div>

      <div className={styles.barContainer}>
        {/* <div className={styles.barPendingPrevet} ></div>
        <div className={styles.barInprogress} ></div>
        <div className={styles.barSigned} ></div>
        <div className={styles.barUnderwriting} ></div>
        <div className={styles.barApproved} ></div>
        <div className={styles.barDeclined} ></div> */}

        {barData.map((bar, index) => (
          <div
            key={index}
            className={styles.bar}
            style={{ width: `${bar.barPercentage}%`, background: bar.color }}
          ></div>
        ))}
      </div>

      <div className={styles.applicationsList}>
        {applicationsData.map((application, index) => (
          <div key={index} className={styles.applicationsListItem}>
            <div className={styles.indicatorContainer}>
              <span
                className={styles.indicatorDot}
                style={{ background: application.color }}
              ></span>
            </div>

            <div className={styles.applicationsListItemContent}>
              <p className={styles.applicationsListItemTitle}>
                {application.title}
              </p>
              <p className={styles.applicationsListItemDate}>
                {application.percentage}% of all applications
              </p>
            </div>

            <div className={styles.numberContainer}>
              <p className={styles.numberValue}>{application.value}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Applications;
